import Button from 'components/ReusableComponents/Button'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import useForm from 'hooks/useForm'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from '../MultiStepPMSLogin.module.scss'

const RegisterApiUser = ({ setUpdateConfig, tenantId }) => {
  const { addToast } = useToasts()
  const [formData, handleFormChange] = useForm({
    tenantId: tenantId || '',
    interfaceId: '',
    interfaceKey: '',
    step: 'Step2ApiUserRegistration'
  })

  const handleFormSubmission = e => {
    e.preventDefault()
    pmsApi
      .setOhipConfiguration(formData)
      .then(() =>
        addToast('Successful', {
          appearance: 'success',
          autoDismiss: true
        })
      )
      .catch(error => {
        addToast(`${error}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setUpdateConfig(prev => prev + 1)
      })
  }

  return (
    <>
      <div className={styles.infoBar}>
        <span>An email is sent to developers with instructions</span>
      </div>
      <div className={styles.stepActions}>
        <form onSubmit={handleFormSubmission}>
          <div className={styles.actionContainer}>
            <div className={styles.inputContainer}>
              <TextInput
                name="interfaceId"
                className={styles.textInput}
                type="string"
                label="Interface id"
                value={formData.interfaceId}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className={styles.inputContainer}>
              <TextInput
                name="interfaceKey"
                className={styles.textInput}
                type="string"
                label="Interface key"
                value={formData.interfaceKey}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className={styles.inputContainer}>
              <Button type="primary" size="small">
                Next
              </Button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default RegisterApiUser
